export default __webpack_public_path__ + "static/media/(46).7966e7ab.jpg";